import { TranslateService } from '@ngx-translate/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { LoyaltyGiftReservationService } from './../../../services/loyalty/loyalty-gift-reservation.service';
import { LoyaltyReservationSearchService } from 'app/services/loyalty/loyalty-reservation-search.service';
import { SelectItem } from 'primeng/primeng';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-loyalty-gift-reservation',
  templateUrl: './loyalty-gift-reservation.component.html',
  styleUrls: ['./loyalty-gift-reservation.component.css']
})
export class LoyaltyGiftReservationComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  selectFilter = KontableComponent.SelectFilter;
  customerId: number;
  customer: string;
  cardNumber: string;
  accumulator: string;
  pointsBalance: number;
  divisionId: number;
  stores: SelectItem[] = [];
  selectedStore: any;
  pointsSpent: number;
  pointsLeft: number;
  contribution: number;
  selectedGifts: any[];
  giftType: SelectItem[] = [];
  deliveryTypes: SelectItem[] = [];
  reservationType: SelectItem[] = [];
  contributionFilter: SelectItem[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    public giftService: LoyaltyGiftReservationService,
    private router: Router,
    public ReservationSearchService: LoyaltyReservationSearchService,
    private translateService: TranslateService
  ) {
    this.divisionId = this.activatedRoute.snapshot.params['divisionId'];
    this.giftService.getDivisionId(this.divisionId);
    sessionStorage.setItem('divisionId', this.divisionId.toString());
    this.getGiftType();
    this.getReservationTypes();
    this.getDeliveryType();
  }

  ngOnInit() {
    this.translateService.get(['common.all', 'common.yes']).subscribe(res => {
      const all = {value: null, label: res['common.all']};
      this.giftType.push(all);
      this.deliveryTypes.push(all);
      this.reservationType.push(all);
      this.contributionFilter.push(all);
      this.contributionFilter.push({value: 'true', label: res['common.yes']});
      this.contributionFilter.push({value: 'false', label: 'NO'});
    });
    this.selectedGifts = JSON.parse(sessionStorage.getItem('selectedGifts')) || [];
    this.pointsSpent = +sessionStorage.getItem('pointsSpent') || 0;
    this.contribution = +sessionStorage.getItem('contribution') || 0;
    this.pointsBalance = +sessionStorage.getItem('startingBalance');
    if (this.pointsSpent === 0) {
      this.pointsLeft = this.pointsBalance;
    } else {
      this.pointsLeft = this.pointsBalance - this.pointsSpent;
    }
    this.customerId = this.activatedRoute.snapshot.params['customerId'];
    this.customer = sessionStorage.getItem('customer');
    this.accumulator = sessionStorage.getItem('acm');
    this.cardNumber = sessionStorage.getItem('cardNo');
    this.giftService.getStores().subscribe(res => {
      res.forEach(store => {
        if(store.name === undefined || store.name === null)
          this.stores.push({ label: store.host_code + ' - --', value: store.id });
        else
          this.stores.push({ label: store.host_code + ' - ' + store.name+ ',' + store.address_1+ ', ' + store.city, value: store.id });
    });
      console.log(this.stores[0])
      this.selectedStore = this.stores[0];
    });
  }

  /**
   * Metodo per recuperare i gift type, che vengono inseriti nel dropdown di ricerca
   */
   getGiftType(){
    //Popolo il dropdown dei gift type
    this.ReservationSearchService.getGiftType().subscribe(el => {
      el.forEach(el => this.giftType.push({ value: el.description, label: el.description }))
    });
  }

  /**
   * Metodo per recuperare i reservation types
   */
  getReservationTypes(){
    this.giftService.getReservationType().subscribe( el => {
      el.forEach(type => { this.reservationType.push({ value: type.description, label: type.description})
      });
    })
  }

  /**
   * Metodo per recuperare i delivery type, che vengono inseriti nel dropdown di ricerca
   */
   getDeliveryType(){
    //Popolo dropdown dei delivery type
    this.ReservationSearchService.getDeliveryType().subscribe(el => {
    el.forEach(el => { this.deliveryTypes.push({ value: el.description, label: el.description })
      })
    });
    console.log(this.deliveryTypes);
  }

  goBack() {
    this.giftService.resetData();
    this.router.navigate([`loyalty/balance/${this.customerId}`]);
  }

  getSelectedItemById(id: number) {
    return this.selectedGifts.find(sGift => sGift.id === id)
  }

  addGift(gift) {
    // Se prezzo premio non supera punti rimasti
    if (gift.rdm_points <= this.pointsLeft) {
      // Se premio non ancora selezionato
      if (!this.getSelectedItemById(gift.itm_id)) {
        this.selectedGifts.push({
          id: gift.itm_id,
          catalogId: gift.catalog_id,
          catalogDesc: gift.catalog_desc,
          code: gift.itm_code,
          name: gift.description,
          points: gift.rdm_points,
          // totalPoints: gift.rdm_points,
          contribution: gift.rdm_value,
          // totalContribution: gift.rdm_value,
          type: gift.type_gift_desc,
          typeId: gift.type_gift_id,
          deliveryType: gift.delivery_type_desc,
          pdv: gift.delivery_type_desc.toUpperCase() === 'PUNTO VENDITA' ? true : false,
          barcode: gift.barcode,
          qty: 1
        });
      } else {
        const giftFound = this.getSelectedItemById(gift.itm_id);
        /* giftFound.totalPoints += gift.rdm_points;
        giftFound.totalContribution += gift.rdm_value; */
        giftFound.qty += 1;
      }
      this.pointsSpent += gift.rdm_points;
      this.pointsLeft -= gift.rdm_points;
      this.contribution = parseFloat((+this.contribution + gift.rdm_value).toFixed(2));
    }
  }

  removeGift(gift) {
    if (this.getSelectedItemById(gift.itm_id)) {
      const giftIndex = this.selectedGifts.findIndex(sGift => sGift.id === gift.itm_id);
      if (this.selectedGifts[giftIndex].qty > 1) {
        this.selectedGifts[giftIndex].qty -= 1;
      } else {
        this.selectedGifts.splice(giftIndex, 1);
      }
      this.pointsSpent -= gift.rdm_points;
      this.pointsLeft += gift.rdm_points;
      this.contribution = parseFloat((+this.contribution - gift.rdm_value).toFixed(2));
    }
  }

  confirmGifts() {
    console.log(this.selectedStore)
    sessionStorage.setItem('customerId', this.customerId.toString());
    sessionStorage.setItem('storeId', this.selectedStore.value.toString());
    sessionStorage.setItem('stores', JSON.stringify(this.stores));
    sessionStorage.setItem('startingBalance', this.pointsBalance.toString());
    sessionStorage.setItem('selectedGifts', JSON.stringify(this.selectedGifts));
    sessionStorage.setItem('pointsLeft', this.pointsLeft.toString());
    sessionStorage.setItem('pointsSpent', this.pointsSpent.toString());
    sessionStorage.setItem('contribution', this.contribution.toString());
    this.router.navigate(['loyalty/confirm-gift-reservation']);
  }

  changeStore(event) {
    this.selectedStore = event;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-gift-reservation/loyalty-gift-reservation.component.ts